<div class="modal-header border-0">
  @if (modalContentData.closeable) {
  <button type="button" class="btn-close" aria-label="Close" (click)="crossClickHandle()"></button>
  }
</div>
<div class="modal-body">
  @if (modalContentData) {
  <div class="d-grid gap-2 col-lg-12 col-md-12 mx-auto">
    <div class="col-md-auto">
      @if (modalContentData.title) {
      <div class="text-center">
        <div class="custom-icon mb-3 animated fadeInDown">
          <svg width="40" height="55" viewBox="0 0 40 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20.0318" cy="30.4677" r="17.6392" fill="#FDDBE3" />
            <path
              d="M11.4958 9.14199C11.4958 8.71678 11.6021 8.39788 11.921 8.07897C12.1867 7.81321 12.5588 7.65376 12.9308 7.70691C14.047 7.86637 16.4388 8.34473 18.2991 10.205C19.9999 11.9059 19.9999 12.7563 19.9999 12.7563C19.9999 12.7563 19.9999 11.9059 21.7008 10.205C23.5611 8.34473 25.9529 7.86637 27.0691 7.70691C27.4411 7.65376 27.8132 7.81321 28.0789 8.07897C28.3978 8.39788 28.5041 8.71678 28.5041 9.14199C28.3978 10.205 27.9195 12.4905 26.3781 14.0319C24.252 16.1579 22.6044 16.2111 19.9999 16.1579C17.3955 16.2111 15.7479 16.1579 13.6218 14.0319C12.0804 12.4905 11.6021 10.205 11.4958 9.14199Z"
              fill="#98B899" />
            <path
              d="M12.984 21.473C16.8641 17.593 23.1359 17.593 27.016 21.473C29.7267 24.1838 30.6302 28.2764 29.2483 31.8907L26.3781 39.6507H20C19.3622 39.6507 18.7775 40.2354 18.7775 40.8732C18.7775 41.511 19.3622 42.0957 20 42.0957H25.5277L21.7008 52.5133C21.3819 53.2574 20.7973 53.7358 20 53.6826C19.2027 53.7358 18.5649 53.2043 18.2992 52.5133L10.7517 31.8907L10.6985 31.8375L16.5983 31.8907C17.2893 31.8375 17.8208 31.306 17.8208 30.6682C17.8208 30.0304 17.2361 29.4457 16.5983 29.4457L10.167 29.4989C9.90128 26.5756 10.858 23.5991 12.984 21.473Z"
              fill="#F48C4C" />
          </svg>
        </div>
        <h2 class="modal-title text-center animated fadeInDown">{{ modalContentData.title }}</h2>
      </div>
      <div class="mobile-ios-top-pad"></div>
      }
      @if (modalContentData.textContent) {
      <div class="text-center mt-2 animated fadeIn mb-5" #textContent></div>
      }
    </div>
  </div>
  }

  @switch (modalContentType) {
  @case (modalContentTypes.CHECK_ADDRESS) {
  <app-check-address></app-check-address>
  <!-- <app-check-address-signup></app-check-address-signup> -->
  }
  @case (modalContentTypes.HOW_IT_WORKS) {
  <app-how-it-works [modalContentData]="modalContentData"></app-how-it-works>
  }

  @case (modalContentTypes.WELCOME_MESSAGE) {
  <app-welcome-message [modalContentData]="modalContentData"></app-welcome-message>
  }

  @case (modalContentTypes.SEND_INFORMATION) {
  <app-send-information [modalContentData]="modalContentData"></app-send-information>
  }

  @case (modalContentTypes.BOX_DETAIL) {
  <app-modal-box-detail [boxDetail]="modalContentData.boxDetail || null"></app-modal-box-detail>
  }
  @case (modalContentTypes.PAUSE_SUBSCRIPTION) {
  <app-pause-subscriptions [data]="modalContentData"></app-pause-subscriptions>
  }
  @case (modalContentTypes.CONFIRMATION) {
  <div class="d-flex justify-content-center gap-4 animated fadeInUp" [class.mt-5]="!modalContentData.textContent">
    @if (modalContentData.cancelButtonText) {
    <button type="button" class="btn btn-outline-primary"
      (click)="confirmModalButtonsAction(false)">{{modalContentData.cancelButtonText}}</button>
    }
    @if (modalContentData.confirmButtonText) {
    <button type="button" class="btn btn-primary"
      (click)="confirmModalButtonsAction(true)">{{modalContentData.confirmButtonText}}</button>
    }
  </div>
  }
  @case (modalContentTypes.SKIP_DELIVERY) {
  <app-skip-delivery></app-skip-delivery>
  }
  @case (modalContentTypes.BECOME_A_MEMBER) {
  <app-become-a-member [data]="modalContentData.becomeAMemeber"></app-become-a-member>
  }
  @case (modalContentTypes.BUY_AGAIN) {
  <app-buy-again-order-history
    [orderHistoryId]="modalContentData.buyAgain?.orderHistoryId"></app-buy-again-order-history>
  }
  @case (modalContentTypes.CHANGE_CREDENTIALS) {
  <app-change-credentials [email]="modalContentData.changeCredentials?.email || ''"></app-change-credentials>
  }

  @case (modalContentTypes.PROSPECT) {
  <app-prospect></app-prospect>
  }

  @case (modalContentTypes.PENDING_PAYMENT_METHOD) {
  <app-pending-payment-method></app-pending-payment-method>
  }

  @case (modalContentTypes.PENDING_PAYMENT_METHOD_NO_SIGNUP) {
  <app-pending-payment-method-no-signup></app-pending-payment-method-no-signup>
  }

  @case (modalContentTypes.MEMBERSHIP_CSA_DEPOSITS) {
  <app-membership-csa-deposit></app-membership-csa-deposit>
  }

  @case (modalContentTypes.DONATION_SKIPPABLE) {
  <app-donation-skippable></app-donation-skippable>
  }

  @case (modalContentTypes.DONATION) {
  <app-donation></app-donation>
  }

  @case (modalContentTypes.TIP) {
  <app-tip></app-tip>
  }

  @case (modalContentTypes.DELETE_TIP_AND_DONATION) {
  <app-delete-tip-donation></app-delete-tip-donation>
  }

  @case (modalContentTypes.HOLD_UP_UPDATE_SUBSCRIPTION) {
  <app-hold-up-subscriptions></app-hold-up-subscriptions>
  }

  @case (modalContentTypes.BUY_AGAIN_WARNING) {
  <app-buy-again-order-history-warning
    [products]="modalContentData.orderHistoryWarning || {products: [], showThirdColumn: true, fromOrder: false}"></app-buy-again-order-history-warning>
  }

  @case (modalContentTypes.PAST_CUT_OFF) {
  <app-past-cut-off></app-past-cut-off>
  }

  @case (modalContentTypes.CHECK_SUBMIT_ORDER) {
  <app-check-submit-order></app-check-submit-order>
  }

  @case (modalContentTypes.ACCOUNT_SUSPENDED) {
  <app-suspended-account></app-suspended-account>
  }

  @case (modalContentTypes.SELECT_DELIVERY_DAY) {
  <app-delivery-day-selection
    [zoneId]="modalContentData.deliveryDaySelection?.zoneId || 0"></app-delivery-day-selection>
  }

  @case (modalContentTypes.SUBSCRIPTION_NEXT_DELIVERY) {
  <app-subscription-next-delivery
    [availableDates]="modalContentData.subscriptionNextDelivery?.availableDates || []"></app-subscription-next-delivery>
  }

  @case (modalContentTypes.PREORDER_PRODUCT) {
  <app-pre-order-product [data]="modalContentData.preOrderProduct"></app-pre-order-product>
  }

  @case (modalContentTypes.RESCHEDULED_ORDER) {
  <app-rescheduled-orders [orders]="modalContentData.rescheduledOrders"></app-rescheduled-orders>
  }

  @case (modalContentTypes.RESUME_SUBSCRIPTION) {
  <app-resume-subscriptions [data]="modalContentData.resumeSubscriptions"></app-resume-subscriptions>
  }

  @case (modalContentTypes.AUTH_NET_PURCHASE) {
  <app-auth-net-purchase [purchaseReqAddFields]="modalContentData.authNetPurchase"></app-auth-net-purchase>
  }

  @case (modalContentTypes.NMI_PURCHASE) {
  <app-nmi-purchase [purchaseReqAddFields]="modalContentData.nmiPurchase"></app-nmi-purchase>
  }

  @case (modalContentTypes.CHANGE_QUANTITY_SUBSCRIPTION) {
  <app-change-quantity-subscription [quantity]="modalContentData.quantity ?? 0"></app-change-quantity-subscription>
  }

  @case (modalContentTypes.EXPLORER_PAYMENT_METHOD) {
  <app-explorer-payment-method [type]="modalContentData.explorerPaymentMethod?.type ?? 'subscription'"></app-explorer-payment-method>
  }

  }

</div>